(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeDialogController', CustomerTypeDialogController);

    CustomerTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerType'];

    function CustomerTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerType) {
        var vm = this;
        vm.customerType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerType.id !== null) {
                CustomerType.update(vm.customerType, onSaveSuccess, onSaveError);
            } else {
                CustomerType.save(vm.customerType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
